export const STEPS = {
	LOGIN: 1,
	OTP: 2,
	SIGN_UP: 3,
	DASHBOARD:4,
};

export const BASE_URL = 'https://detoxa-dev.herokuapp.com';
